import { render, staticRenderFns } from "./tablaModulo.vue?vue&type=template&id=61d3543c&scoped=true&"
import script from "./tablaModulo.vue?vue&type=script&lang=js&"
export * from "./tablaModulo.vue?vue&type=script&lang=js&"
import style0 from "./tablaModulo.vue?vue&type=style&index=0&id=61d3543c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3543c",
  null
  
)

export default component.exports